import { render } from "./CreateSalesReturnPage.vue?vue&type=template&id=19d8aa88&ts=true"
import script from "./CreateSalesReturnPage.vue?vue&type=script&lang=ts"
export * from "./CreateSalesReturnPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__